import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import {ChannelMapping} from "../../models/channelMapping";
import {Observable} from "rxjs";

export class ChannelMappingDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.CHANNELMAPPINGS, apiHelper);
    }

    public getByProviderId(providerId: string): Observable<ChannelMapping[]> {
        const url = this.apiHelper.getServiceName() + this.getResource() + `/provider/${providerId}`;
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'GET', null, null, headers);
    }

    public getByProviderIds(providerIds: string[]): Observable<GetByProviderIdsRes[]> {
        const url = this.apiHelper.getServiceName() + this.getResource() + `/getByProviderIds`;
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, { providerIds: providerIds }, headers);
    }

    public bulkCreate(channelMappings: ChannelMapping[]): Observable<ChannelMapping[]> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/bulk';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, channelMappings, headers);
    }

    public bulkUpdate(updates: { id: string, updates: Object }[]): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/update/bulk';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'PUT', null, updates, headers);
    }

    public updateById(id: string, updates: Object): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + `/${id}`;
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'PUT', null, updates, headers);
    }

    public bulkDelete(body: { ids: string[] }): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/delete/bulk';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, body, headers);
    }
}

export interface GetByProviderIdsRes {
    providerId: string;
    mappings: ChannelMapping[];
}
